import React from "react";
import { STATUS_STYLES, STATUS_LABELS } from "../lib/api";

export default function StatusBadge({ status }) {
    const cls = STATUS_STYLES[status] || STATUS_STYLES.pendente;
    const label = STATUS_LABELS[status] || status;
    return (
        <span
            data-testid={`status-badge-${status}`}
            className={`inline-flex items-center rounded-sm border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[0.12em] ${cls}`}
        >
            {label}
        </span>
    );
}
